<template>
    <div class="my-order">
        <div class="mo-btn">
            <van-cell-group custom-class="goods-cell-group" style="width: 110px" :border="false">
                <van-cell is-link @click="">
                    <span style="font-size: 12px">我的电子订单</span>
                </van-cell>
            </van-cell-group>
        </div>
        <div class="mo-list">
            <van-row class="user-links">
                <van-col @click="toMyOrder(item)" v-for="item in items">
                    <van-icon :class="'iconfont '+ item.tmIcon" size="25" style="color: #2b94ff;display: block"/>
                    {{item.menuName}}
                </van-col>
            </van-row>
        </div>
    </div>
</template>

<script>
    import {getDeptId} from "../../../utils/auth";

    export default {
        components: {
        },
        data() {
            return {
                deptId: '',
                phone: '',
                bps: [],
                ysItem: {},
                items: [],
            };
        },
        props: {
            item: Object
        },
        async created() {
            this.ysItem = this.item
            this.deptId = getDeptId()
            this.getStyleMenus()
        },
        methods: {
            async getStyleMenus() {
                let data = {
                    deptId: this.deptId,
                    styleId: this.ysItem.id,
                    isShow: "0",
                }
                let res = await this.$get("/spm/getSpmStyleMenus", data)
                this.items = res.list
            },

            toMyOrder(item) {
                this.$router.push('/myOrder/' + this.deptId + '/' + item.route)
            },
        },
    };
</script>

<style lang="scss" scoped>

    .my-order {
        background-color: #FFFFFF;
        margin: 0 8px 8px 8px;
        border-radius: 5px;
    }
    /*margin-top: -15px;*/
    .mo-btn {
        display: flex;
        flex-direction: row-reverse;
    }

    .mo-list {
        width: 95%;
        margin: auto;
        border-top: #e0e0e0 solid 1px;
    }


    .user-links {
        padding: 10px 0;
        font-size: 12px;
        text-align: center;
        background-color: #fff;
    }

    .user-links .van-icon {
        display: block;
        font-size: 24px;
        height: 28px;
    }

    .user-links .van-row {
        padding: 10px 0;
    }

    .user-links .van-col {
        float: left;
        box-sizing: border-box;
        min-height: 0.02667rem;
        width: 25%;
        margin: 12px 0;
    }
    ::v-deep .van-cell {
        position: relative;
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        box-sizing: border-box;
        width: 100%;
        padding: 8px 3px;
        overflow: hidden;
        color: #323233;
        font-size: 0.37333rem;
        line-height: 0.61rem;
        background-color: #fff;
    }

    .user-links .van-icon {
        display: block;
        font-size: 0.64rem;
        height: 32px;
    }

</style>
